<template>
  <div class="section-main__warp linkage-page">
    <ioc-table :data="tableData" :option="option" :page="page" @search-change="handleSearchChange"
      @search-reset="handleSearchChange" @size-change="handleSizeChange" @current-change="handleCurrentChange">
      <template #menu="{ row, index }">
        <el-tooltip effect="dark" content="详情" placement="top" popper-class="tooltip-draw">
          <el-button type="text" icon="iconfont icon-Detail" @click="handleView(row)" />
        </el-tooltip>
      </template>
    </ioc-table>
    <AppPanel :width="740" class="app-panel" :isExpand="infoVisible" title="规则触发详情" @cancel="handleCloseLinkagePanel">
      <link-record-info :logData="logData" />
    </AppPanel>
  </div>
</template>

<script>
import utils from "$utils";
import AppPanel from "@/components/business/app-panel";
import LinkRecordInfo from "@ISS/linkage/components/linkRecordInfo";

export default {
  name: "linkRecord",
  components: { LinkRecordInfo, AppPanel },
  data() {
    return {
      logData: {},
      tableData: [],
      option: {
        view: "预约详情",
        page: true,
        selection: true,
        index: true,
        indexLabel: "序号",
        stripe: true,
        align: "left",
        size: "small",
        maxHeight: "100%",
        labelWidth: "100px",
        menuAlign: "center",
        searchMenuSpan: 6,
        dialogHeight: 400,
        dialogWidth: "700px",
        emptyText: "暂无数据",
        column: [
          {
            label: "规则名称",
            prop: "ruleName",
            search: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            span: 12
          },
          {
            label: "触发时间",
            prop: "triggerTime",
            type: 'datetimerange',
            search: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            span: 12
          },
          {
            label: "告警设备",
            prop: "deviceName",
            search: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            span: 12
          },
          {
            label: "告警编号",
            prop: "alarmNum",
            search: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            span: 12
          }, {
            label: "告警类型",
            prop: "eventType",
            search: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            span: 12
          }, {
            label: "触发结果",
            prop: "state",
            type: 'select',
            search: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            span: 12,
            dicData: [{
              label: '成功',
              value: 0
            },
            {
              label: '失败',
              value: 1
            }]
          }
        ]
      },
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      infoVisible: false
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      // let startTime = ''
      // let endTime = ''
      // if (this.searchParams && this.searchParams.triggerTime && this.searchParams.triggerTime.length > 0) {
      //   startTime =
      //     new Date(this.searchParams.triggerTime[0].replace(/-/g, '/')).getTime() / 1000 + ''
      //   endTime =
      //     new Date(this.searchParams.triggerTime[1].replace(/-/g, '/')).getTime() / 1000 + ''
      // }
      let state = null
      if (this.searchParams && this.searchParams.triggerTime && this.searchParams.state !== -1) {
        state = this.searchParams.state
      }
      const param = {
        startTime: (this.searchParams && this.searchParams.triggerTime) ? this.searchParams.triggerTime[0] : '',
        endTime: (this.searchParams && this.searchParams.triggerTime) ? this.searchParams.triggerTime[1] : '',
        state,
        ...this.searchParams,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      }
      this.$fetch('/bas/linkage-rule/log/getByPage.json', param).then(res => {
        if (res.success) {
          this.tableData = res.returnObj.list
          this.page.total = res.returnObj.total
        }
      })
    },
    handleCloseLinkagePanel() {
      this.infoVisible = false
    },
    handleView(obj) {
      this.infoVisible = true
      this.$fetch('/bas/linkage-rule/log/getDetails.json', { logId: obj.logId }).then(res => {
        if (!res.success) {
          return
        }
        this.logData = res.returnObj
      })
    },
    handleCurrentChange(val) {
      this.page.currentPage = val
      this.getList()
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val
      this.getList()
    },
    handleSearchChange(param) {
      this.page.currentPage = 1;
      this.searchParams = Object.assign({}, param);
      console.info('this.searchParams', this.searchParams)
      this.getList();
    },
  }
}
</script>

<style scoped></style>
